import React, { useContext, useEffect, useRef, useState } from 'react'
import './ShribetsStarline.css'
import CurrentDayTime from '../14-currentDate/CurrentDayTime'
import arrow from '../../images/arrow.svg'
import Navbar from '../01-navbar/Navbar'
import axios from 'axios'
import { format } from 'date-fns'
import { LoaderContext } from '../15-loader/LoaderProvider'
import Loader from '../15-loader/Loader'

const ShribetsStarline = () => {

    const tableTop = useRef(null);
    const tableBottom = useRef(null);

    const { setIsLoading } = useContext(LoaderContext);
    const { isLoading } = useContext(LoaderContext);

    const topToTable = () => {
        window.scrollTo({
            top: tableTop.current.offsetTop,
            behavior: 'instant',
        });
    }

    const bottomToTable = () => {
        window.scrollTo({
            top: tableBottom.current.offsetTop,
            behavior: 'instant',
        });
    }

    const [starlineChartApiData, setStarlineChartApiData] = useState([]);

    const getChart = async () => {
        await axios.get(`${process.env.REACT_APP_BASE_URL}/web/starlineChart`)
            .then((response) => {
                setStarlineChartApiData(response.data.data?.data)
                setIsLoading(false)
            })
            .catch((err) => console.log(err.message))
    }

    // console.log('======================================', starlineChartApiData);

    useEffect(() => {

        getChart()

    }, [])

    const DateToLocalDayString = (date) => format(new Date(date), 'dd');
    const DateToLocalMonthString = (date) => format(new Date(date), 'MMM');
    const DateToLocalYearString = (date) => format(new Date(date), 'yyyy');
    const TimeToLocalTimeString = (time) => format(new Date(time), 'hh a');

    const dateForOpen = (time) => new Date(`${new Date().toDateString()} ${time}`)



    function sumGetLastDigit(value) {

        if (value == null) {
            return null;
        } else {
            return (
                value
                    .toString()
                    .split('')
                    .map(Number)
                    .reduce(function (a, b) {
                        return a + b;
                    }, 0) % 10
            );
        }
    }



    return (

        <>

            <div className='shribet-navbar' ref={tableTop}><Navbar /></div>

            {/* {
                isLoading ? <Loader/> :  */}


            <div className='shribets-starline' >

                <div className='shribets-starline-content'>

                    <div className='container'>

                        <div className='shribets-starline-heading' ><h2>SHRI STARLINE CHART</h2></div>

                        <div className='shribets-starline-button'>
                            <div className='shribets-starline-bottom-button' onClick={bottomToTable}><span className='arrow-icon'><img src={arrow} /></span><span className='back'>BOTTOM</span></div>
                        </div>

                        <div className='chart' >

                            <table className="table align-middle text-center">

                                <thead className='table-head'>
                                    {/* 
                                    <tr>
                                        <th className='table-head-date'>Date</th>
                                        <th className='table-head-time'>10 AM</th>
                                        <th className='table-head-time'>11 AM</th>
                                        <th className='table-head-time'>12 PM</th>
                                        <th className='table-head-time'>01 PM</th>
                                        <th className='table-head-time'>02 PM</th>
                                        <th className='table-head-time'>03 PM</th>
                                        <th className='table-head-time'>04 PM</th>
                                        <th className='table-head-time'>05 PM</th>
                                        <th className='table-head-time'>06 PM</th>
                                        <th className='table-head-time'>07 PM</th>
                                        <th className='table-head-time'>08 PM</th>
                                        <th className='table-head-time'>09 PM</th>
                                    </tr> */}

                                    <tr>
                                        <th className='table-head-date'>Date</th>
                                        {
                                            starlineChartApiData[0]?.Time.map((data, index) => {

                                                {/* console.log(data.Name) */ }

                                                return (
                                                        <th className='table-head-time' key={data.Name}>{data?.Name}</th>

                                                )

                                            })
                                        }
                                    </tr>

                                </thead>

                                <tbody className='table-body'>

                                    {
                                        starlineChartApiData.map((data, index) =>

                                            <tr key={index}>

                                                <th className='table-date'>

                                                    <div className='table-body-date'>
                                                        <div className='table-date-year'><h6>{DateToLocalYearString(data.Date)}</h6></div>
                                                        <div className='table-date-day'><h6>{DateToLocalDayString(data.Date)}</h6><h6>{DateToLocalMonthString(data.Date)}</h6></div>
                                                    </div>

                                                </th>

                                                {
                                                    data.Time.map((e, index) =>

                                                        <td key={index}>

                                                            <div className='table-result'>
                                                                <div className='starline-result-ank'><h6>{e.Result ? e.Result : <div className='star'>***</div>}</h6></div>
                                                                <div className='starline-main-result'><h6>{e.Result ? sumGetLastDigit(e.Result) : <div className='star'>*</div>}</h6></div>
                                                            </div>

                                                        </td>

                                                    )
                                                }

                                            </tr>

                                        )
                                    }

                                </tbody>

                            </table>

                        </div>

                        {/* <div className='chart' >

                                <table className="table align-middle text-center">
                                    <thead className='table-head'>
                                        <tr>
                                            <th className='table-head-date'>Date</th>
                                            <th>10 AM</th>
                                            <th>11 AM</th>
                                            <th>12 PM</th>
                                            <th>01 PM</th>
                                            <th>02 PM</th>
                                            <th>03 PM</th>
                                            <th>04 PM</th>
                                            <th>05 PM</th>
                                            <th>06 PM</th>
                                            <th>07 PM</th>
                                            <th>08 PM</th>
                                            <th>09 PM</th> 
                                        </tr>
                                    </thead>
                                    <tbody className='table-body'>

                                        <tr>
                                            <th className='table-date'>
                                                <div className='table-body-date'>
                                                    <div className='table-date-year'><h6>2023</h6></div>
                                                    <div className='table-date-day'><h6>25</h6><h6>May</h6></div>
                                                </div>
                                            </th>

                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            

                                        </tr>
                                        <tr>
                                            <th className='table-date'>
                                                <div className='table-body-date'>
                                                    <div className='table-date-year'><h6>2023</h6></div>
                                                    <div className='table-date-day'><h6>25</h6><h6>May</h6></div>
                                                </div>
                                            </th>

                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            

                                        </tr>
                                        <tr>
                                            <th className='table-date'>
                                                <div className='table-body-date'>
                                                    <div className='table-date-year'><h6>2023</h6></div>
                                                    <div className='table-date-day'><h6>25</h6><h6>May</h6></div>
                                                </div>
                                            </th>

                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            

                                        </tr>
                                        <tr>
                                            <th className='table-date'>
                                                <div className='table-body-date'>
                                                    <div className='table-date-year'><h6>2023</h6></div>
                                                    <div className='table-date-day'><h6>25</h6><h6>May</h6></div>
                                                </div>
                                            </th>

                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            

                                        </tr>
                                        <tr>
                                            <th className='table-date'>
                                                <div className='table-body-date'>
                                                    <div className='table-date-year'><h6>2023</h6></div>
                                                    <div className='table-date-day'><h6>25</h6><h6>May</h6></div>
                                                </div>
                                            </th>

                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            

                                        </tr>
                                        <tr>
                                            <th className='table-date'>
                                                <div className='table-body-date'>
                                                    <div className='table-date-year'><h6>2023</h6></div>
                                                    <div className='table-date-day'><h6>25</h6><h6>May</h6></div>
                                                </div>
                                            </th>

                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            

                                        </tr>
                                        <tr>
                                            <th className='table-date'>
                                                <div className='table-body-date'>
                                                    <div className='table-date-year'><h6>2023</h6></div>
                                                    <div className='table-date-day'><h6>25</h6><h6>May</h6></div>
                                                </div>
                                            </th>

                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='table-result'>
                                                    <div className='starline-result-ank'><h6>124</h6></div>
                                                    <div className='starline-main-result'><h6>7</h6></div>
                                                </div>
                                            </td>
                                            

                                        </tr>
                                        

                                    </tbody>
                                </table>


                            </div> */}

                        <div className='shribets-starline-button'>
                            <div className='shribets-starline-top-button' onClick={topToTable} ref={tableBottom} ><span className='arrow-icon'><img src={arrow} /></span><span className='back'>TOP</span></div>
                        </div>

                    </div>

                </div>

            </div >

            {/* } */}


        </>
    )
}

export default ShribetsStarline
